import { useSelector } from 'react-redux'
import { WizardProvider } from '../../../../shared/WizardContext'
import { STEPS } from '../../../../../store/slices/scheduleTour'
import { selectScheduleTourStep } from '../../../../../store/slices/scheduleTour'
import ScheduleTourModal from './Modal'

export const ScheduleTourWizard = () => {
  const currentStep = useSelector(selectScheduleTourStep)

  return (
    <WizardProvider steps={STEPS} initialStep={currentStep}>
      <ScheduleTourModal />
    </WizardProvider>
  )
}
